import locales from './locales';

export default function t(lang, key, params = {}) {
  let text = locales[lang]?.[key] || locales['en']?.[key] || key;
  for (const [paramKey, paramValue] of Object.entries(params)) {
    text = text.replace(`{{${paramKey}}}`, String(paramValue));
  }
  return text;
}
